import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor";
var wxsModules = {};
global.currentModuleId = "_ff7d3170";
global.currentSrcMode = "wx";
global.currentInject = { "moduleId": "_ff7d3170" };
/** script content **/
require("./tab-bar.ts?ctorType=component&index=0&isComponent&lang=ts&mpx&outputPath=components%2Findexff7d3170%2Findex&resourcePath=%2Fhome%2Frunner%2Fwork%2Fmpx-cube-ui%2Fmpx-cube-ui%2Fpackages%2Fmpx-cube-ui%2Fsrc%2Fcomponents%2Ftab-bar%2Findex.mpx&type=script");
export default processComponentOption({
    option: global.__mpxOptionsMap["_ff7d3170"],
    ctorType: "component",
    outputPath: "components/indexff7d3170/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: { 'cube-tab': getComponent(require("./tab.mpx?isComponent&outputPath=components%2Ftab66c6e44b%2Findex")) },
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
});
